export const rupiah = (n) =>
  "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");

export const numberFmt = (n) =>
  (Number(n) || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 });

export const dateFmt = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
};

export const dateTimeFmt = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  return d.toLocaleString("id-ID", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};

export const timeFmt = (s) => {
  if (!s) return "-";
  return new Date(s).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
